export default "__VITE_ASSET__aeMV6jx8__"